export default {
  "app_label": "estimation",
  "model_name": "exportmappingline",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "help_text": null,
      "hidden": true,
      "identifier": true,
      "data_type": "int",
      "search": false,
      "sort": false
    },
    {
      "name": "export_mapping_label",
      "label": "Export mapping label",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "search": true,
      "sort": true
    },
    {
      "name": "subheading",
      "label": "Subheading",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "label",
      "search": true,
      "sort": true
    },
    {
      "name": "product",
      "label": "Product",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "name",
      "search": true,
      "sort": true
    },
    {
      "name": "usage",
      "label": "Usage",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "label",
      "search": true,
      "sort": true
    },
    {
      "name": "multiplier",
      "label": "Multiplier",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "Decimal",
      "search": true,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": false
    }
  ],
  "filter_by": [
    {
      "label": "Product",
      "name": "product",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:estimation:product:autocomplete",
        "key": "pk",
        "display": "name",
        "pagination": true
      }
    },
    {
      "label": "Usage",
      "name": "usage",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:estimation:lineusage:autocomplete",
        "key": "pk",
        "display": "label",
        "pagination": true
      }
    },
    {
      "label": "Subheading",
      "name": "subheading",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:estimation:subheading:autocomplete",
        "key": "pk",
        "display": "label",
        "pagination": true
      }
    },
    {
      "label": "Export mapping",
      "name": "export_mapping",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:estimation:exportmapping:autocomplete",
        "key": "pk",
        "display": "label",
        "pagination": true
      }
    }
  ],
  "export_import": null
}